let prefix = '/api/departments';

function getDepartments(){
    return window.axios.get(prefix+'/index');
}

export default {
    getDepartments,
}